import Button from "devextreme-react/button";
import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { LoadPagePanel } from "../../../../components";
import { AR } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useCancelChangeOrder } from "../api/cancel-change-order";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function CancelChangeOrderButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	let cancelChangeOrder = useCancelChangeOrder(
		order.details.retailOrderID,
		() => {
			showSuccessMessage('Change order request has been cancelled');
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				text="Cancel Change Order"
				icon="Inscyth-Cancel"
				elementAttr={{ 'data-testid': 'btn-cancel-change-order' }}
				visible={order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) ||
					order.details.activeARs.includes(AR.SageToApproveChangeOrder)}
				disabled={cancelChangeOrder.isLoading}
				onClick={() => {
					confirm("Are you sure you want to cancel the change order request?",
						"Cancel Change Order Request")
						.then(result => {
							if (result) {
								cancelChangeOrder.mutate();
							}
						});
				}} >
			</Button>
			<LoadPagePanel visible={cancelChangeOrder.isLoading}></LoadPagePanel>
		</>
	)
}
